var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVector6({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.91634 16.6003L6.18631 15.5843L6.19565 15.5772C6.46041 15.3653 6.59401 15.2585 6.74307 15.1823C6.8768 15.114 7.0194 15.0642 7.1665 15.034C7.33231 15 7.50503 15 7.85173 15H15.0859C16.0175 15 16.4838 15 16.84 14.8185C17.1536 14.6587 17.4087 14.4035 17.5685 14.0899C17.75 13.7337 17.75 13.2679 17.75 12.3363V5.99744C17.75 5.06584 17.75 4.59935 17.5685 4.24317C17.4087 3.92957 17.1531 3.67479 16.8395 3.515C16.483 3.33334 16.0169 3.33334 15.0835 3.33334H5.41683C4.48341 3.33334 4.01635 3.33334 3.65983 3.515C3.34623 3.67479 3.09144 3.92957 2.93166 4.24317C2.75 4.59969 2.75 5.06675 2.75 6.00017V15.5593C2.75 16.4474 2.75 16.8914 2.93205 17.1194C3.09037 17.3178 3.33036 17.4332 3.58415 17.4329C3.87596 17.4326 4.22287 17.1551 4.91634 16.6003Z",
    stroke: "#00AA5B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector6);
export default __webpack_public_path__ + "static/media/vector6.eff520c7181ce9075afcec1932020695.svg";
export { ForwardRef as ReactComponent };